import React from "react";
import DonatePage from "../../components/DonatePage/DonatePage";
import Layout from "../../components/shared/Layout/Layout";

const Donate = () => {
  return (
    <Layout>
      <div>
        <DonatePage />
      </div>
    </Layout>
  );
};

export default Donate;
